// Third party
import React from 'react';

// Utils
import { FormattedMessage } from '@/utils/i18n';
import { PERMISSIONS, userHasPermissionEnabled } from '@/utils/permissions';

// Components
import ComparisonActionCards from '@/views/components/misc/ComparisonActionCards';
import ComparisonQuickSearch from '../misc/ComparisonQuickSearch';

// Types
import User from '@/types/user';

type Props = {
  user: User;
  showEditPortfolioModal: () => void;
};

const LinkStartComparison = ({ user, showEditPortfolioModal }: Props) => (
  <div className="empty-comparison">
    <div className="empty-comparison-container">
      <div className="empty-comparison-content">
        <div className="title">
          <FormattedMessage tagName="h1" id="LinkEmptyComparison.Title" />
          <FormattedMessage tagName="p" id="EmptyComparison.Subtitle" />
        </div>

        <ComparisonQuickSearch user={user} />

        {userHasPermissionEnabled(user, PERMISSIONS.PORTFOLIOS_CREATE) && (
          <ComparisonActionCards
            className="empty-options"
            hasClientAccountPermission={false}
            hasModelPortfolioPermission={false}
            hasNewPortfolioPermission
            onClickPortfolio={showEditPortfolioModal}
          />
        )}
      </div>
    </div>
  </div>
);

export default LinkStartComparison;
